export default "__VITE_ASSET__D7agNBp0__"